import IDatePicker, { IDatePickerProps } from './datePicker';
import IRangePicker from './rangePicker';
const DatePicker = IDatePicker;
DatePicker.RangePicker = IRangePicker;
export default DatePicker;
